import type { Block, BlockItem } from '../Block';

export interface Deps {
  block: Block;
}

export type GetBlockUIProps = BlockItem;
